import React from 'react'
import { ColorConstants } from '../../utilities/Enums'

interface Props {
    text: string;
}

const Head1Text = (props: Props) => {
  return (
    <p style={{ fontWeight: 'bold', padding: '8px', paddingLeft: '12px', color: ColorConstants.PrimaryColor, fontSize: '16px', margin: '0px', cursor: 'pointer' }}>{props.text}</p>
  )
}

export default Head1Text


// WEBPACK FOOTER //
// ./src/components/common/Head1Text.tsx